var React = require('react');

function AiAdminOnboardingPrompt (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.11766 3H13.8824C14.3155 3 14.6667 3.35115 14.6667 3.78431V4.21569C14.6667 4.64885 14.3155 5 13.8824 5H2.11766C1.68449 5 1.33334 4.64885 1.33334 4.21569V3.78431C1.33334 3.35115 1.68449 3 2.11766 3ZM2.11766 7H11.5294C11.9626 7 12.3137 7.35115 12.3137 7.78431V8.21569C12.3137 8.64885 11.9626 9 11.5294 9H2.11766C1.68449 9 1.33334 8.64885 1.33334 8.21569V7.78431C1.33334 7.35115 1.68449 7 2.11766 7ZM9.17648 11H2.11766C1.68449 11 1.33334 11.3511 1.33334 11.7843V12.2157C1.33334 12.6489 1.68449 13 2.11766 13H9.17648C9.60964 13 9.96079 12.6489 9.96079 12.2157V11.7843C9.96079 11.3511 9.60964 11 9.17648 11Z","fill":"currentColor"}));
}

AiAdminOnboardingPrompt.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = AiAdminOnboardingPrompt;

AiAdminOnboardingPrompt.default = AiAdminOnboardingPrompt;
